import uuid from "uuid";

/**
 * The Analysis base model which is used to define all the static analayses
 */
export default class StaticAnalysis {
  /**
   *
   * @param {Object} data
   * @param {String} data.id Id of the analysis
   * @param {String} data.name Name of the analaysis
   * @param {Object} data.static_entity  StaticEntity meta data {entityType, entityName, etc.}
   */
  constructor({ type, id, name, static_entity }) {
    this.type = type;
    this.id = id || uuid.v4();
    this.name = name;
    this.static_entity = static_entity;
  }
}
